const Unit = {
    PSI: 'PSI',
    MA: 'mA',
    TEETH: 'Teeth',
    HZ: 'Hz',
    MV: 'mV',
    CC: 'cc',
} as const;

export default Unit;
